var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.36111 3.5C3.88553 3.5 3.5 3.88553 3.5 4.36111V15.6389C3.5 16.0209 3.74869 16.3447 4.09298 16.4574L12.6919 7.85856C12.9848 7.56566 13.4596 7.56566 13.7525 7.85856L16.5 10.606V4.36111C16.5 3.88553 16.1145 3.5 15.6389 3.5H4.36111ZM16.5 12.7273L13.2222 9.44955L6.17174 16.5H15.6389C16.1145 16.5 16.5 16.1145 16.5 15.6389V12.7273ZM2 4.36111C2 3.05711 3.05711 2 4.36111 2H15.6389C16.9429 2 18 3.05711 18 4.36111V15.6389C18 16.9429 16.9429 18 15.6389 18H4.36111C3.05711 18 2 16.9429 2 15.6389V4.36111ZM7.18056 6.7222C6.92743 6.7222 6.72223 6.9274 6.72223 7.18053C6.72223 7.43366 6.92743 7.63887 7.18056 7.63887C7.43369 7.63887 7.6389 7.43366 7.6389 7.18053C7.6389 6.9274 7.43369 6.7222 7.18056 6.7222ZM5.22223 7.18053C5.22223 6.09897 6.099 5.2222 7.18056 5.2222C8.26212 5.2222 9.1389 6.09897 9.1389 7.18053C9.1389 8.26209 8.26212 9.13887 7.18056 9.13887C6.099 9.13887 5.22223 8.26209 5.22223 7.18053Z",
    fill: "#3F434A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/imageIcon.54b84d99019eeeb27f3497ab24f02922.svg";
export { ForwardRef as ReactComponent };